import React from 'react';
import type { GetTrackProps, TrackItem } from 'react-compound-slider';

import { RangeInputTrack } from 'src/components/molecules/RangeInput/styles';

export interface RangeInputTracksProps {
  tracks: TrackItem[];
  getTrackProps: GetTrackProps;
}

export const RangeInputTracks = ({ tracks, getTrackProps }: RangeInputTracksProps) => (
  <>
    {tracks.map(({ id, source, target }) => (
      <RangeInputTrack
        key={id}
        sourcePercent={source.percent}
        targetPercent={target.percent}
        {...getTrackProps()}
      />
    ))}
  </>
);
